import { useEffect, useState } from "react";
import { supabase } from "../providers/supabase/supabase";
import { mapaSegmentoPorGrupo, type Segmento } from "./segmentoVenda";

/**
 * Carrega o mapa grupo → segmento uma vez, para a aba de Vendas inteira.
 *
 * Fica num hook só (e não em cada card) porque a página precisa do mapa em
 * dois lugares — o rótulo de cada venda e a tradução do filtro Imóvel/Móvel em
 * lista de grupos — e são poucas centenas de grupos: uma consulta por página é
 * barata, uma por card não seria.
 *
 * Falha de leitura não derruba nada de propósito: sem o mapa o card mostra "-"
 * no segmento e o filtro fica sem efeito, que é bem melhor do que a lista de
 * vendas inteira sumir por causa de um campo acessório.
 */
export const useSegmentoPorGrupo = () => {
  const [mapa, setMapa] = useState<Map<string, Segmento>>(() => new Map());
  const [carregado, setCarregado] = useState(false);

  useEffect(() => {
    let cancelado = false;

    (async () => {
      const { data } = await supabase.from("servopa_groups").select("group_number, segment");
      if (cancelado) return;
      setMapa(mapaSegmentoPorGrupo(data));
      setCarregado(true);
    })().catch(() => {
      if (!cancelado) setCarregado(true);
    });

    return () => {
      cancelado = true;
    };
  }, []);

  return { segmentoPorGrupo: mapa, carregado };
};
